<router-outlet></router-outlet>
<!--
<app-layout></app-layout>
<app-toolbar></app-toolbar>
  <app-side-menu></app-side-menu>

  <mat-drawer-container class="example-container">
    <mat-drawer mode="side" opened>Drawer content</mat-drawer>
    <mat-drawer-content>Main content</mat-drawer-content>
  </mat-drawer-container>
  <mat-sidenav-container>
    <mat-sidenav>Start</mat-sidenav>
    <mat-sidenav-content>Main</mat-sidenav-content>
  </mat-sidenav-container>

      <div style="height: 88vh;"></div>
    <footer></footer>

  -->
